import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormControl, FormHelperText, FormLabel, Select, } from '@chakra-ui/react';
import { AuthContext } from '../../../contexts/auth-context';
import { ISite } from '../../../models/site';
import admin from '../../../api/admin';
import { GetSitesResponse } from '../../../models/admin-api/dto';

const SiteLookupComponent = (props: any) => {

  const [sites, setSites] = useState<ISite[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    admin.Sites.GetSites(props.organisation)
      .then((response: GetSitesResponse) => {
        setSites(response.result);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [props.organisation]);

  return (
    <>
      <FormControl isRequired={props.isRequired}>
        <FormLabel>{props.label}</FormLabel>
        <Select
          id={props.id}
          name={props.id}
          disabled={props.disabled}
          value={props.value}
          onChange={props.onChange}
          onError={props.error}
          defaultValue={null}

        >
          <option value={null}></option>
          {sites?.length ? (
            sites.map((site:ISite) => (<option value={site.siteId as number}>{site.address}</option >))
          ) : (
            <option >loading...</option >
          )}
        </Select>
        {props.error ? (
          <FormHelperText
            sx={{ color: '#bf3333', marginLeft: '16px !important' }}
          >
            {props.helperText}
          </FormHelperText>
        ) : null}
      </FormControl>
    </>
  );
};

SiteLookupComponent.propTypes = {
  error: PropTypes.bool,
  helperText: PropTypes.any,
  id: PropTypes.string,
  name: PropTypes.string,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.any,
  organisation: PropTypes.number,
  size: PropTypes.string,
  fontWeight: PropTypes.string,
  fontSize: PropTypes.string
}

export default SiteLookupComponent;
